function pickUpAccordion(): void {
  const moreButton = document.querySelector<HTMLButtonElement>(".js-25thanniversary-pickup-more");
  const items = document.querySelectorAll<HTMLElement>(".p-25thanniversary-pickup__item");

  if (!moreButton || items.length === 0) return;

  // 5つ目以降のアイテムにクラスとaria属性を付与
  const hiddenItems = Array.from(items).slice(4); // 0-indexed, 5つ目以降を取得
  hiddenItems.forEach((item) => {
    item.classList.add("p-25thanniversary-pickup__item--hidden");
    item.setAttribute("aria-hidden", "true");
    item.style.maxHeight = "0";
  });
  let isExpanded = false; // アコーディオンの状態を追跡

  const updateVisibility = () => {
    const isSmallScreen = window.innerWidth <= 767;
    const hasMoreThanFourItems = items.length > 4;

    if (isSmallScreen && hasMoreThanFourItems) {
      if (moreButton) {
        moreButton.style.display = "flex";
      }
      hiddenItems.forEach((item) => {
        if (!isExpanded) { // アコーディオンが開いていない場合のみ非表示にする
          item.style.maxHeight = "0";
          item.setAttribute("aria-hidden", "true");
        }
      });
    } else {
      if (moreButton) {
        moreButton.style.display = "none";
      }
      hiddenItems.forEach((item) => {
        item.style.maxHeight = "none";
        item.setAttribute("aria-hidden", "false");
      });
    }
  };

  moreButton.addEventListener("pointerup", () => {

    isExpanded = !isExpanded; // 状態をトグル
    hiddenItems.forEach((item) => {
      if (isExpanded) {
        item.style.maxHeight = `${item.scrollHeight}px`;
        item.setAttribute("aria-hidden", "false");
      } else {
        item.style.maxHeight = "0";
        item.setAttribute("aria-hidden", "true");
      }
    });

    moreButton.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    moreButton.textContent = isExpanded ? "閉じる" : "もっと見る";
  });

  window.addEventListener("resize", updateVisibility);
  updateVisibility();
}

export { pickUpAccordion };
